exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center[data-v-5759451f]{-webkit-box-sizing:content-box;box-sizing:content-box;max-width:var(--measure);margin-right:auto;margin-left:auto}", ""]);

// exports
